import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Grid } from '@mui/material';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import React, { useEffect } from 'react';
import {
    IRestrictionsFormSection
} from '../../interfaces';


export const RestrictionsFormSection: React.SFC<IRestrictionsFormSection> = ({
    material,
    onUpdate,
    ...props
}: IRestrictionsFormSection) => {

    useEffect(() => {


    }, [material])



    const getRestrictions = () => {
        return ["No", "Yes"];
    }



    return (
        <Accordion
            defaultExpanded={true}
        >
            <AccordionSummary
                expandIcon={<ExpandMore />}
            >
                <DialogContentText color="primary">
                    Restrictions & Paperwork
                </DialogContentText>
            </AccordionSummary>
            <AccordionDetails>

                <Grid container>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        <Autocomplete
                            id="material-restrictions"
                            options={getRestrictions()}
                            value={material.hasUsageRestrictions || null}
                            onChange={(_, value) => onUpdate("hasUsageRestrictions", value)}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Restrictions on Usage?"
                                required
                            />}
                        />

                    </Grid>

                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Paperwork Ref"
                            value={material.paperWorkReceived}
                            onChange={(e) => onUpdate("paperWorkReceived", e.currentTarget.value)}
                        />
                    </Grid>

                    {material.hasUsageRestrictions?.toUpperCase() === "YES" &&
                        <Grid item={true} xs={8} sx={{ p: 0.5 }}>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                required
                                variant="outlined"
                                label="Details of Restrictions"
                                value={material.usageRestrictions}
                                onChange={(e) => onUpdate("usageRestrictions", e.currentTarget.value)}
                            />
                        </Grid>
                    }

                </Grid>

            </AccordionDetails>
        </Accordion>

    );
}